//import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, set, child, get, push, update, runTransaction,
    onChildAdded, onChildChanged, onChildRemoved, orderByChild, query, limitToLast } from "firebase/database";
import { getAuth } from "firebase/auth";

// Initialize Firebase
import app from 'services/firebase'

// Initialize Realtime Database and get a reference to the service
const database = getDatabase(app);


function writeUserData(userId, name, email, imageUrl) {
  const db = getDatabase();
  set(ref(db, 'users/' + userId), {
    username: name,
    email: email,
    profile_picture : imageUrl
  });
}

export const HandleSetRealTimeDB = {set, get, ref, database, onValue, push, getDatabase, child, update};
/**
 * //add completion
set(ref(db, 'users/' + userId), {
  username: name,
  email: email,
  profile_picture : imageUrl
})
.then(() => {
  // Data saved successfully!
})
.catch((error) => {
  // The write failed...
});
 */

/* const starCountRef = ref(db, 'posts/' + postId + '/starCount');
onValue(starCountRef, (snapshot) => {
  const data = snapshot.val();
  //updateStarCount(postElement, data);
}); */



//read data once
/* 
const dbRef = ref(getDatabase());
get(child(dbRef, `users/${userId}`)).then((snapshot) => {
  if (snapshot.exists()) {
    console.log(snapshot.val());
  } else {
    console.log("No data available");
  }
}).catch((error) => {
  console.error(error);
}); */



//read data once with an observer

const db = getDatabase();
const auth = getAuth();

/* const userId = auth.currentUser.uid;
return onValue(ref(db, '/users/' + userId), (snapshot) => {
  const username = (snapshot.val() && snapshot.val().username) || 'Anonymous';
  // ...
}, {
  onlyOnce: true
}); */


//update, delete

function writeNewPost(uid, username, picture, title, body) {

  // A post entry.
  const postData = {
    author: username,
    uid: uid,
    body: body,
    title: title,
    starCount: 0,
    authorPic: picture
  };

  // Get a key for a new Post.
  const newPostKey = push(child(ref(db), 'posts')).key;

  // Write the new post's data simultaneously in the posts list and the user's post list.
  const updates = {};
  updates['/posts/' + newPostKey] = postData;
  updates['/user-posts/' + uid + '/' + newPostKey] = postData;

  return update(ref(db), updates);
}


//transaction

function toggleStar(uid) {
  const db = getDatabase();
  const postRef = ref(db, '/posts/foo-bar-123');

  runTransaction(postRef, (post) => {
    if (post) {
      if (post.stars && post.stars[uid]) {
        post.starCount--;
        post.stars[uid] = null;
      } else {
        post.starCount++;
        if (!post.stars) {
          post.stars = {};
        }
        post.stars[uid] = true;
      }
    }
    return post;
  });
}


//atomic updates
/* function addStar(uid, key) {
    const updates = {};
    updates[`posts/${key}/stars/${uid}`] = true;
    updates[`posts/${key}/starCount`] = firebase.database.ServerValue.increment(1);
    updates[`user-posts/${key}/stars/${uid}`] = true;
    updates[`user-posts/${key}/starCount`] = firebase.database.ServerValue.increment(1);
    firebase.database().ref().update(updates);
  } */

  //list operation

// Create a new post reference with an auto-generated id
const postListRef = ref(db, 'posts');
const newPostRef = push(postListRef);
set(newPostRef, {
    // ...
});



/* const commentsRef = ref(db, 'post-comments/' + postId);
onChildAdded(commentsRef, (data) => {
//  addCommentElement(postElement, data.key, data.val().text, data.val().author);
});

onChildChanged(commentsRef, (data) => {
  //setCommentValues(postElement, data.key, data.val().text, data.val().author);
});

onChildRemoved(commentsRef, (data) => {
  //deleteComment(postElement, data.key);
});
 */

//listen for value event

const dbRefe = ref(db, '/a/b/c');

onValue(dbRefe, (snapshot) => {
  snapshot.forEach((childSnapshot) => {
    const childKey = childSnapshot.key;
    const childData = childSnapshot.val();
    // ...
  });
}, {
  onlyOnce: true
});


//ordering

//const myUserId = auth.currentUser.uid;
//const topUserPostsRef = query(ref(db, 'user-posts/' + myUserId), orderByChild('starCount'));



//part 2

const mostViewedPosts = query(ref(db, 'posts'), orderByChild('metrics/views'));

/**
 * limitToFirst()	Sets the maximum number of items to return from the beginning of the ordered list of results.
limitToLast()	Sets the maximum number of items to return from the end of the ordered list of results.
startAt()	Return items greater than or equal to the specified key or value, depending on the order-by method chosen.
startAfter()	Return items greater than the specified key or value depending on the order-by method chosen.
endAt()	Return items less than or equal to the specified key or value, depending on the order-by method chosen.
endBefore()	Return items less than the specified key or value depending on the order-by method chosen.
equalTo()
 */

//e.g
const recentPostsRef = query(ref(db, 'posts'), limitToLast(100));